import React, { FC, useMemo } from 'react'
import { Heading } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import { ReportCardCancellationSteps, useReportCardCancellationModalContext } from '../ReportCardCancellationModalContext'

const namespace = 'report-card-cancellation-navigation'
const I18N_NAMESPACE = ['account']

export const ReportCardCancellationNavigation: FC = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { step } = useReportCardCancellationModalContext()

  const title = useMemo(() => {
    switch (step) {
      case ReportCardCancellationSteps.Initial:
      case ReportCardCancellationSteps.Decline:
        return t('account:tab:payment-methods:reportCardCancellationModal:title:decline')
      case ReportCardCancellationSteps.SelectCard:
        return t('account:tab:payment-methods:reportCardCancellationModal:title:selectCard')
      case ReportCardCancellationSteps.Confirm:
        return t('account:tab:payment-methods:reportCardCancellationModal:title:confirm')
    }

    return ''
  }, [t, step])

  return (
    <div className='text-center'>
      <Heading testNameSpace={namespace} size='L'>
        {title}
      </Heading>
    </div>
  )
}
